import { gql } from '@apollo/client/core';
import { imageBlockFragment } from './image-block.fragment';

export const linkedLogoItemBlockFragment = gql`
  fragment LinkedLogoItemBlockFields on LinkedLogoItemBlock {
    entryTitle
    redirectUrl
    logoCollection(limit: 1) {
      items {
        ... on ImageBlock {
          image {
            url
            title
          }
          altText
        }
      }
    }
  }
  ${imageBlockFragment}
`;

export const linkedLogosBlockFragment = gql`
  fragment LinkedLogosBlockFields on LinkedLogosBlock {
    sys {
      id
    }
    entryTitle
    linkedLogosTitle: title
    description
    logosCollection(limit: 10) {
      items {
        ...LinkedLogoItemBlockFields
      }
    }
  }
  ${linkedLogoItemBlockFragment}
`;
